module.exports = __webpack_public_path__ + "static/img/329.eb0a650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/329.jpg
// module id = XVy3
// module chunks = 0